export default __webpack_public_path__ + "static/media/902.58efb59b.gif";